export default "__VITE_ASSET__91f988db__"